import { render, staticRenderFns } from "./aftersale.vue?vue&type=template&id=4611c610&scoped=true&"
import script from "./aftersale.vue?vue&type=script&lang=js&"
export * from "./aftersale.vue?vue&type=script&lang=js&"
import style0 from "./aftersale.vue?vue&type=style&index=0&id=4611c610&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4611c610",
  null
  
)

export default component.exports